import Space from 'antd/lib/space';
import * as React from 'react';
import { PullRequest, PullRequestMergeQueueState, PullRequestStatus } from '../../types';
import { PullRequestOutlined, LinkOutlined } from '@ant-design/icons';
import { antGrey, runwayColors } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Link from 'antd/lib/typography/Link';
import Button from 'antd/lib/button';
import Tag from 'antd/lib/tag';
import orangeDot from '../../../assets/orange-dot-8.svg';

const PullRequestComponent: React.FC<PullRequest> = (props: PullRequest) => {
    const isPullRequestOpen = props.status === PullRequestStatus.Open;
    const isPullRequestMerged = props.status === PullRequestStatus.Merged;
    const isPullRequestQueued = props.mergeQueueState === PullRequestMergeQueueState.Queued;

    return (
        <Space style={{ marginTop: 8 }} size={8}>
            <Space size={6}>
                {isPullRequestMerged && <LinkOutlined style={{ color: antGrey.grey7 }} />}
                {isPullRequestOpen && <PullRequestOutlined style={{ color: antGrey.grey7 }} />}
                {isPullRequestOpen && !isPullRequestQueued && (
                    <Text style={{ color: antGrey.grey8 }}>PR #{props.number}</Text>
                )}
                {isPullRequestOpen && isPullRequestQueued && (
                    <Link href={props.url} target="_blank">
                        PR #{props.number}
                    </Link>
                )}
                {isPullRequestMerged && (
                    <Link href={props.url} target="_blank">
                        PR #{props.number}
                    </Link>
                )}
            </Space>
            {isPullRequestOpen && isPullRequestQueued && (
                <Tag color={runwayColors.info} style={{ margin: 0 }}>
                    In merge queue
                </Tag>
            )}
            {isPullRequestOpen && !isPullRequestQueued && (
                <Button href={props.url} target="_blank" icon={<img src={orangeDot} style={{ marginRight: 6 }} />}>
                    Resolve
                </Button>
            )}
        </Space>
    );
};

export default PullRequestComponent;
